
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"32pt","height":"32pt","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13 4v12.844l-2.375 8.5 1.938.531 2.187-7.781 3.094.343c.293.032.55.165.718.407.168.242.231.558.157.843L16.594 28h2.062l2-7.844a2.967 2.967 0 00-.437-2.437 3.034 3.034 0 00-2.157-1.282L15 16.095v-1.938l4.281.563c1.184.133 2.176.926 2.532 2.062L25.313 28h2.125l-3.72-11.813a4.971 4.971 0 00-4.187-3.468L15 12.125V4zm-4.5 7A3.514 3.514 0 005 14.5C5 16.422 6.578 18 8.5 18s3.5-1.578 3.5-3.5S10.422 11 8.5 11zm0 2c.84 0 1.5.66 1.5 1.5S9.34 16 8.5 16 7 15.34 7 14.5 7.66 13 8.5 13z"}})])
          )
        }
      }
    